import React, { ReactElement } from 'react';

import Link from 'atomic/link/link';
import Icon from 'atomic/icon/icon';

import './socials.scss';

import instagramSvg from 'assets/icons/instagram.inline.svg';

interface CompanyViewInfoMetadataSocialsProps {
    facebook?: string;
    instagram?: string;
}

const CompanyViewInfoMetadataSocials: React.FC<CompanyViewInfoMetadataSocialsProps> = ({ facebook, instagram }): ReactElement => {
    const items = [];

    if (facebook) {
        items.push(
            {
                url: facebook,
                icon: <Icon icon="fb" className="company-view-info__metadata-fb" />
            }
        );
    }

    if (instagram) {
        items.push(
            {
                url: instagram,
                icon: <img src={instagramSvg} alt={instagram} className="company-view-info__metadata-instagram" />
            }
        );
    }

    return (
        <div>
            {items.map(item => (
                <Link key={item.url} href={item.url} className="company-view-info__metadata-social-link"
                    target="_blank" rel="nofollow" wrapper={true}
                >
                    {item.icon}
                </Link>
            ))}
        </div>
    );
};

export default CompanyViewInfoMetadataSocials;
